/**
 * ControlsRight
 * 
 * 职责：右侧控制按钮组（字幕模式、显示设置）
 */

import React from 'react';
import { SubtitleModeToggle } from './SubtitleModeToggle';
import { DisplaySettingsButton } from './DisplaySettingsButton';

interface ControlsRightProps {
  subtitleModeLabel: string;
  showDisplaySettingsPanel: boolean;
  disabled: boolean;
  onSubtitleModeClick: () => void;
  onDisplaySettingsClick: () => void;
}

export const ControlsRight: React.FC<ControlsRightProps> = ({
  subtitleModeLabel,
  showDisplaySettingsPanel,
  disabled,
  onSubtitleModeClick,
  onDisplaySettingsClick,
}) => {
  return (
    <div className="control-buttons-right">
      <SubtitleModeToggle
        label={subtitleModeLabel}
        disabled={disabled}
        onClick={onSubtitleModeClick}
      />
      <DisplaySettingsButton
        isActive={showDisplaySettingsPanel}
        disabled={disabled}
        onClick={onDisplaySettingsClick}
      />
    </div>
  );
};

